export const environment = {
  production: true,
  apiUrl: "https://6zdijnt6d0.execute-api.us-east-1.amazonaws.com/production/trea/api",
  extraApiUrl: "add7m77yn4m",
};
